module.exports = __webpack_public_path__ + "img/92139.57059157.svg";